import { render, staticRenderFns } from "./PhoneTextField.vue?vue&type=template&id=2ebae3ea&scoped=true&"
import script from "./PhoneTextField.vue?vue&type=script&lang=js&"
export * from "./PhoneTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebae3ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
